import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import {colors, fontSize, fontWeight, spacing, borderRadius} from '@/styles/tokens';

// ─── Module-level sx constants (was `.mobile-process-*` / `.process-coin*` / `.process-header-wrapper` in globals.scss) ──
const PROCESS_COIN_COLORS = ['#9dd533', '#46cf93', '#68c6d1', '#309de7', '#4565a7', '#6d67c4'] as const;

const processHeaderWrapperSx = {
    display: 'flex',
    alignItems: 'center',
    gap: spacing[12]
} as const;

const processCoinBaseSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: spacing[60],
    height: spacing[60],
    minWidth: spacing[60],
    textAlign: 'center',
    fontWeight: fontWeight.bold,
    fontSize: fontSize[28],
    borderRadius: borderRadius.circle,
    color: colors.text.inverse
} as const;

const mobileProcessHeadingSx = {
    fontWeight: fontWeight.bold,
    fontSize: fontSize[20],
    '& a': {
        textDecoration: 'none',
        color: colors.text.primary
    },
    '& a:hover': {
        textDecoration: 'underline'
    }
} as const;

const mobileProcessSubheadingSx = {
    fontSize: fontSize[16],
    fontWeight: fontWeight.regular,
    marginTop: spacing[16],
    WebkitMarginAfter: 0,
    marginBlockEnd: 0,
    lineHeight: '27px', // no exact token match at 27px
    letterSpacing: '0.00938em'
} as const;
// ─────────────────────────────────────────────────────────────────────────────

interface MobileProcessItem {
    heading?: string;
    description?: string;
}

interface MobileProcessProps {
    mobileProcess?: MobileProcessItem[];
}

const MobileProcess = (props: MobileProcessProps) => {
    const {mobileProcess} = props;
    return (
        <Box>
            {mobileProcess?.map((item: MobileProcessItem, index: number) => (
                <Box key={index + 1} pb={5}>
                    <Box sx={processHeaderWrapperSx}>
                        <Box sx={{...processCoinBaseSx, backgroundColor: PROCESS_COIN_COLORS[index]}}>{index + 1}</Box>

                        <Typography sx={mobileProcessHeadingSx}>{item.heading ? parse(item.heading) : ''}</Typography>
                    </Box>
                    <Box>
                        <Typography className="ai-agent-done-subheading" sx={mobileProcessSubheadingSx}>
                            {item.description ? parse(item.description) : ''}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default memo(MobileProcess);
